import { FormEvent, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { dashboardDisponivel } from "Config";
import { useAuth } from "shared/hooks/auth";
import { paginaEntradaMof } from "shared/helpers/paginaEntrada";
import { mensagemDeErro } from "services/auth";
import { AvisoErro, CartaoAcesso } from "./components/CartaoAcesso";

/**
 * Login próprio do MOF novo (plano de 07/10/2026, B1.1) — substitui o link para o MOF antigo.
 * O token emitido é o mesmo do legado; quem entra pelo MOF antigo (?hashId=) continua entrando.
 */
export function Login() {
  const { signIn, signed, havePermission } = useAuth();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  // Já logado (ou acabou de entrar): vai para a página de entrada do usuário.
  if (signed) {
    return <Navigate to={paginaEntradaMof(havePermission, dashboardDisponivel())} replace />;
  }

  const handleSubmit = async (evento: FormEvent) => {
    evento.preventDefault();
    setErro(null);

    if (!email.trim() || !senha) {
      setErro("Informe o e-mail e a senha.");
      return;
    }

    setEntrando(true);
    try {
      await signIn({ email: email.trim(), senha });
    } catch (e: any) {
      setErro(mensagemFalhaLogin(e));
      setEntrando(false);
    }
  };

  return (
    <CartaoAcesso
      titulo="Login"
      rodape={
        <small>
          Ao entrar, concordo com os Termos e Políticas da Alumisoft Sistemas.
        </small>
      }
    >
      <form onSubmit={handleSubmit} noValidate>
        <AvisoErro mensagem={erro} />
        <div className="mb-3">
          <label className="form-label" htmlFor="login-email">
            E-mail
          </label>
          <input
            id="login-email"
            type="email"
            className="form-control"
            placeholder="Email..."
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
        </div>
        <div className="mb-2">
          <label className="form-label d-flex justify-content-between" htmlFor="login-senha">
            Senha
            <Link to="/esqueciSenha" className="link-secondary small">
              Esqueci minha senha
            </Link>
          </label>
          <input
            id="login-senha"
            type="password"
            className="form-control"
            placeholder="Senha..."
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>
        <div className="form-footer mt-4">
          <button type="submit" className="btn btn-mof w-100" disabled={entrando}>
            {entrando ? "ENTRANDO..." : "ENTRAR"}
          </button>
        </div>
      </form>
    </CartaoAcesso>
  );
}

function mensagemFalhaLogin(erro: any): string {
  switch (erro?.status) {
    case 400:
      return mensagemDeErro(erro, "Informe o e-mail e a senha.");
    case 401:
      return mensagemDeErro(erro, "Usuário e/ou senha inválidos");
    case 403:
      return mensagemDeErro(erro, "Usuário inativo. Procure o administrador da sua empresa.");
    case 429:
      return mensagemDeErro(erro, "Muitas tentativas. Aguarde 15 minutos.");
    default:
      return "Não foi possível entrar agora. Tente novamente em instantes.";
  }
}
